import { useEffect, useState } from "react";
import { Swords, Flame, Sparkles } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import ChallengeCard from "@/components/ChallengeCard";
import ChallengeRunner from "@/components/ChallengeRunner";
import { Markdown } from "@/components/Markdown";

export default function Challenges() {
  const { refreshUser } = useAuth();
  const [challenges, setChallenges] = useState([]);
  const [daily, setDaily] = useState(null);

  const load = () => {
    api.get("/challenges").then((r) => setChallenges(r.data)).catch(() => {});
    api.get("/challenges/daily").then((r) => setDaily(r.data)).catch(() => {});
  };

  useEffect(() => {
    load();
  }, []);

  const handleDailyResult = async (result) => {
    setDaily((prev) => (prev ? { ...prev, completed_today: !result.already_completed && result.passed ? true : prev.completed_today, daily_streak: result.daily_streak } : prev));
    if (result.xp_awarded > 0) {
      await refreshUser();
      load();
    }
  };

  return (
    <div className="space-y-8" data-testid="challenges-page">
      <div className="animate-fade-up">
        <div className="flex items-center gap-2">
          <Swords className="h-7 w-7 text-primary" strokeWidth={2.5} />
          <h1 className="font-heading font-black text-3xl sm:text-4xl tracking-tight">Challenges</h1>
        </div>
        <p className="text-muted-foreground font-medium mt-1">Löse auto-bewertete Aufgaben in Python, C++ und Java.</p>
      </div>

      {daily && (
        <div className="nb-card p-5 sm:p-6 bg-accent" data-testid="daily-challenge-card">
          <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
            <div className="flex items-center gap-2">
              <Sparkles className="h-6 w-6" strokeWidth={2.5} />
              <h2 className="font-heading font-black text-xl sm:text-2xl">Tages-Challenge: {daily.title}</h2>
            </div>
            <div className="flex items-center gap-1 bg-warning border-2 border-black rounded-lg px-2.5 py-1 nb-shadow-sm">
              <Flame className="h-4 w-4" strokeWidth={2.5} />
              <span className="font-bold text-sm" data-testid="daily-streak">{daily.daily_streak} Tage</span>
            </div>
          </div>
          <Markdown className="mb-4">{daily.description_md}</Markdown>
          {daily.completed_today && (
            <p className="font-bold text-sm bg-success/70 border-2 border-black rounded-lg px-3 py-2 mb-4 inline-block">
              ✅ Heute schon gelöst — du kannst trotzdem weiter üben.
            </p>
          )}
          <ChallengeRunner
            language={daily.language}
            starterCode={daily.starter_code}
            submitUrl="/challenges/daily/submit"
            onResult={handleDailyResult}
          />
        </div>
      )}

      <div>
        <h2 className="font-heading font-black text-2xl mb-4">Alle Challenges</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {challenges.map((c) => (
            <ChallengeCard key={c.id} challenge={c} />
          ))}
        </div>
      </div>
    </div>
  );
}
